module.exports = __webpack_public_path__ + "static/sport/footer2.0654e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/footer2.png
// module id = qleh
// module chunks = 0